export default {
    formDetail: {
        path: '/form/detail',
        name: 'form-detail',
        component: () => import('@/views/form/form-detail.vue')
    },
    application: {
        testApplication: {
            path: 'testApplication/:schemaCode',
            name: 'testApplication',
            component: () => import('./views/application-list.vue')
        },
    },
};
